import { connect } from 'react-redux'
import ContentsOfCampaignComponent from '../components/contents_of_campaign'
import DisplayActions from '../../../../redux/DisplayRedux'

const mapStateToProps = ({ display, userAccount }) => ({
  libraryContents: display.libraryContents,
  cart: display.cart,
  listOfContentsInCampaign: display.listOfContentsInCampaign,
  loadingListOfContentsInCampaign: display.loadingListOfContentsInCampaign,
  listResolutionWithContent: display.listResolutionWithContent,
  customContents: display.customContents,
  toleranceResolution: display.toleranceResolution,
  listOfContentsInCampaign: display.listOfContentsInCampaign,
  isSuperUser: userAccount.isSuperUser,
  editCampaignActive: display.editCampaignActive,
  currentCampaign: display.currentCampaign,
  listOfContentsInCampaign: display.listOfContentsInCampaign,
  initialBackup: display.initialBackup,
  hasInitialBackup: display.hasInitialBackup,
  toleranceResolutionInit: display.toleranceResolutionInit,
  creationType: display.creationType,
  placeholders: display.placeholders,
  fetchingPlaceholders: display.fetchingPlaceholders,
  listOfPlaceholdersInCampaign: display.listOfPlaceholdersInCampaign,
  listResolutionWithPlaceholders: display.listResolutionWithPlaceholders,
  reportSingleData: display.reportSingleData,
})

const mapStateToDispatch = (dispatch) => ({
  clearCustomContents: () => dispatch(DisplayActions.clearCustomContents()),
  setListOfContentsInCampaign: (listOfContentsInCampaign) => dispatch(DisplayActions.setListOfContentsInCampaign(listOfContentsInCampaign)),
  updateCustomContents: (customContents) => dispatch(DisplayActions.updateCustomContents(customContents)),
  deleteContentFromCampaign: (contentId) => dispatch(DisplayActions.deleteContentFromCampaign(contentId)),
  cleanListOfContentsInCampaign: () => dispatch(DisplayActions.cleanListOfContentsInCampaign()),
  remplaceContentForUniqueVersion: (contentId, listDisplay, contentToReplace ) => dispatch(DisplayActions.remplaceContentForUniqueVersion(contentId, listDisplay, contentToReplace )),
  removeRelationFromDisplay: (relation) => dispatch(DisplayActions.removeRelationFromDisplay(null, relation)),
  setListResolutionWithContent: (listResolutionWithContent) => dispatch(DisplayActions.setListResolutionWithContent(listResolutionWithContent)),
  updateListOfContentsInCampaign: (listOfContentsInCampaign) => dispatch(DisplayActions.updateListOfContentsInCampaign(listOfContentsInCampaign)),
  setToleranceResolution: (toleranceResolution) => dispatch(DisplayActions.setToleranceResolution(toleranceResolution)),
  removeRelationsOnCampaign: (displayId, contentId) => dispatch(DisplayActions.removeRelationsOnCampaign(displayId, contentId)),
  setInitialBackup: (initialBackup) => dispatch(DisplayActions.setInitialBackup(initialBackup)),
  restoreCampaignToOriginalState: () => dispatch(DisplayActions.restoreCampaignToOriginalState()),
  updateImpressionsDisplay: (displayId, contentId, impressions) => dispatch(DisplayActions.updateImpressionsDisplay(displayId, contentId, impressions)),
  getPlaceholders: (listResolution) => dispatch(DisplayActions.getPlaceholdersRequest(listResolution)),
  setListOfPlaceholdersInCampaign: (placeholders) => dispatch(DisplayActions.setListOfPlaceholdersInCampaign(placeholders)),
  setListResolutionWithPlaceholders: (listResolutionWithPlaceholders) => dispatch(DisplayActions.setListResolutionWithPlaceholders(listResolutionWithPlaceholders)),
})

export default connect(mapStateToProps, mapStateToDispatch)(ContentsOfCampaignComponent)